import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule, { settings } from ".";

export const definition: WidgetDefinition = {
  id: "ott-piracy-indicator",
  module: widgetModule,
  catalog: {
    description: "One or two figures of the OTT piracy report, with their trend.",
    domain: "ott-piracy",
    visual: "KPI",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", skeleton: "kpi" },
  settings,
  defaultLayoutClassName: "col-span-12 xl:col-span-4",
};
